export default __webpack_public_path__ + "static/smoke_detector_w.3f10c3c71307d8727f37b6e7ca4b352c.png";